import { baseApi } from "./baseApi";

export const fleetManagementApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCarModels: builder.query<any, void>({
      query: () => ({
        url: `/fleets/car-models`,
        method: "GET",
      }),
    }),

    getAllFleets: builder.query<any, { company_id?: string; page?: number }>({
      query: ({ company_id, page } = {}) => ({
        url: company_id
          ? `/fleets/companies/${company_id}${page ? `?page=${page}` : ""}`
          : "/fleets/companies",
        method: "GET",
      }),
      providesTags: ["Fleets"],
    }),

    // ✅ Get specific fleet details
    getFleetById: builder.query<any, { fleet_id: string }>({
      query: ({ fleet_id }) => ({
        url: `/fleets/${fleet_id}`,
        method: "GET",
      }),
      providesTags: (result, error, { fleet_id }) => [
        { type: "Fleets", id: fleet_id },
      ],
    }),

    createFleet: builder.mutation<any, any>({
      query: (payload) => ({
        url: `/fleets`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["planLimit", "Fleets"],
    }),

    getAllBranches: builder.query<any, { user_id: string }>({
      query: ({ user_id }) => ({
        url: `/branches/all-branches?user_id=${user_id}`,
        method: "GET",
      }),
    }),

    deleteFleet: builder.mutation<any, { fleet_id: string }>({
      query: ({ fleet_id }) => ({
        url: `/fleets/${fleet_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["planLimit", "Fleets"],
    }),

    updateFleet: builder.mutation<any, { fleet_id: string; data: any }>({
      query: ({ fleet_id, data }) => ({
        url: `/fleets/${fleet_id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["planLimit", "Fleets"],
    }),
  }),
});

export const {
  useGetAllCarModelsQuery,
  useGetAllFleetsQuery,
  useGetFleetByIdQuery,
  useCreateFleetMutation,
  useGetAllBranchesQuery,
  useDeleteFleetMutation,
  useUpdateFleetMutation,
} = fleetManagementApi;